export const GET_MEMBER_INFO_REQUEST = 'GET_MEMBER_INFO_REQUEST';
export const GET_MEMBER_INFO_REQUEST_SENT = 'GET_MEMBER_INFO_REQUEST_SENT';
export const GET_MEMBER_INFO_REQUEST_SUCCEEDED = 'GET_MEMBER_INFO_REQUEST_SUCCEEDED';
export const GET_MEMBER_INFO_REQUEST_FAILED = 'GET_MEMBER_INFO_REQUEST_FAILED';

export const STORE_MEMBER_INFO = 'STORE_MEMBER_INFO';
